import React from 'react';
import { Routes, Route } from "react-router-dom";
import AdcuCheckerReportsModule from './adcu-checker-reports-module/adcu-checker-reports-module';

const AdcuCheckerReports = () => {
  return (
    <Routes>
      <Route index element={<AdcuCheckerReportsModule />} />
    </Routes>
  )
}

export default AdcuCheckerReports;